/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import InputBox from '../../../components/InputBox'
import Dropdown from '../../../components/Dropdown'
import {useState,useContext} from 'react'
import GlobalContext from '../../../components/Context/GloablContext'


export default function VitalInformation({type,setType,emptyField,setEmptyField,vitalInfoFields,setVitalInfoFields,setIsDisableCancel}) {
    
    

    const {setToastmessage, isSideNavBar,UpdateCall, setUpdateCall,setToastErrorMessage} =useContext(GlobalContext)
    function handleOnChangeInput(id,option) {
        setToastErrorMessage("")
        setEmptyField(false)
       
        const fieldToUpdate = {
            blood_glucose: "blood_glucose",
            blood_pressure: "blood_pressure",
            temperature: "temperature",
            spo2: "spo2",
            pulse: "pulse",
            weight: "weight",
            height: "height",
        }[id];

        if (fieldToUpdate) {
            setIsDisableCancel(false)
            setVitalInfoFields((prev) => ({
                ...prev,
                [fieldToUpdate]: option,
            }));
        }         
        
    }
    return (
        <div className='mt-5'>
            <h1 className='mb-5 text-lg font-normal text-black'>Vital Information</h1>
            <div className='px-6 py-4 rounded-lg bg-[#E7EAF4]'>
                {type === "add"||type==="edit" ? 
                    <>
                        <div className='flex -mx-[18px] flex-wrap'>
                            <div className='w-1/3 px-[18px] mb-5'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"Blood Glucose"}
                                        id={"blood_glucose"}
                                        value={vitalInfoFields.blood_glucose}
                                        placeholder={'Select UoM'}
                                        options={['mmol/L','mg/dL']}
                                        handleOnChangeInput={handleOnChangeInput}
                                        emptyField={emptyField&&vitalInfoFields.blood_glucose===""}

                                    />
                                </div>
                            </div>
                            <div className='w-1/3 px-[18px] mb-5'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"Blood Pressure"}
                                        id={"blood_pressure"}
                                        placeholder={'Select UoM'}
                                        value={vitalInfoFields.blood_pressure}
                                        options={['mmHg']}
                                        handleOnChangeInput={handleOnChangeInput}
                                        emptyField={emptyField&&vitalInfoFields.blood_pressure===""}
                                    />
                                </div>
                            </div>
                            <div className='w-1/3 px-[18px] mb-5'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"Temperature"}
                                        id={"temperature"}
                                        placeholder={'Select UoM'}
                                        value={vitalInfoFields.temperature}
                                        options={['℃','℉']}
                                        handleOnChangeInput={handleOnChangeInput}
                                        emptyField={emptyField&&vitalInfoFields.temperature===""}
                                    />
                                </div>
                            </div>
                            <div className='w-1/3 px-[18px] mb-5'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"SPO2"}
                                        id={"spo2"}
                                        placeholder={'Select UoM'}
                                        value={vitalInfoFields.spo2}
                                        options={['%']}
                                        handleOnChangeInput={handleOnChangeInput}
                                        emptyField={emptyField&&vitalInfoFields.spo2===""}
                                    />
                                </div>
                            </div>
                            <div className='w-1/3 px-[18px] mb-5'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"Pulse"}
                                        id={"pulse"}
                                        placeholder={'Select UoM'}
                                        value={vitalInfoFields.pulse}
                                        options={['bpm']}
                                        handleOnChangeInput={handleOnChangeInput}
                                        emptyField={emptyField&&vitalInfoFields.pulse===""}
                                    />
                                </div>
                            </div>
                            <div className='w-1/3 px-[18px] mb-5'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"Weight"}
                                        id={"weight"}
                                        placeholder={'Select UoM'}
                                        value={vitalInfoFields.weight}
                                        options={['lbs','kg']}
                                        handleOnChangeInput={handleOnChangeInput}
                                        emptyField={emptyField&&vitalInfoFields.weight===""}
                                    />
                                </div>
                            </div>
                            <div className='w-1/3 px-[18px]'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"Height"}
                                        id={"height"}
                                        placeholder={'Select UoM'}
                                        value={vitalInfoFields.height}
                                        options={['cm','in']}
                                        handleOnChangeInput={handleOnChangeInput}
                                        emptyField={emptyField&&vitalInfoFields.height===""}
                                    />
                                </div>
                            </div>
                        </div>
                    </> 
                    : 
                    <>
                        <div className='flex -mx-1 flex-wrap'>
                            <div className='px-1 w-1/5 mb-8'>
                                <div className='w-full'>
                                    <p className='text-xs font-normal text-[#000] pb-1.5'>Blood Glucose</p>
                                    <p className='text-base font-normal text-[#000B17]'>{vitalInfoFields?.blood_glucose===""?"-":vitalInfoFields?.blood_glucose}</p>
                                </div>
                            </div>
                            <div className='px-1 w-1/5 mb-8'>
                                <div className='w-full'>
                                    <p className='text-xs font-normal text-[#000] pb-1.5'>Blood Pressure</p>
                                    <p className='text-base font-normal text-[#000B17]'>{vitalInfoFields?.blood_pressure===""?"-":vitalInfoFields?.blood_pressure}</p>
                                </div>
                            </div>
                            <div className='px-1 w-1/5 mb-8'>
                                <div className='w-full'>
                                    <p className='text-xs font-normal text-[#000] pb-1.5'>Temperature</p>
                                    <p className='text-base font-normal text-[#000B17]'>{vitalInfoFields?.temperature===""?"-":vitalInfoFields?.temperature}</p>
                                </div>
                            </div>
                        </div>
                        <div className='flex -mx-1 flex-wrap'>
                            <div className='px-1 w-1/5 mb-8'>
                                <div className='w-full'>
                                    <p className='text-xs font-normal text-[#000] pb-1.5'>SPO2</p>
                                    <p className='text-base font-normal text-[#000B17]'>{vitalInfoFields?.spo2===""?"-":vitalInfoFields?.spo2}</p>
                                </div>
                            </div>
                            <div className='px-1 w-1/5 mb-8'>
                                <div className='w-full'>
                                    <p className='text-xs font-normal text-[#000] pb-1.5'>Pulse</p>
                                    <p className='text-base font-normal text-[#000B17]'>{vitalInfoFields?.pulse===""?"-":vitalInfoFields?.pulse}</p>
                                </div>
                            </div>
                            <div className='px-1 w-1/5 mb-8'>
                                <div className='w-full'>
                                    <p className='text-xs font-normal text-[#000] pb-1.5'>Weight</p>
                                    <p className='text-base font-normal text-[#000B17]'>{vitalInfoFields?.weight===""?"-":vitalInfoFields?.weight}</p>
                                </div>
                            </div>
                        </div>
                        <div className='flex -mx-1 flex-wrap'>
                            <div className='px-1 w-1/5 mb-8'>
                                <div className='w-full'>
                                    <p className='text-xs font-normal text-[#000] pb-1.5'>Height</p>
                                    <p className='text-base font-normal text-[#000B17]'>{vitalInfoFields?.height===""?"-":vitalInfoFields?.height}</p>
                                </div>
                            </div>
                        </div>
                    </>
                }
                
            </div>
        </div>
    )
}
